import { render, staticRenderFns } from "./AcceleratorProposal.vue?vue&type=template&id=52d4ba56&"
import script from "./AcceleratorProposal.vue?vue&type=script&lang=js&"
export * from "./AcceleratorProposal.vue?vue&type=script&lang=js&"
import style0 from "./AcceleratorProposal.vue?vue&type=style&index=0&id=52d4ba56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports